export default "__VITE_ASSET__CVvxS5UH__"